<app-modal
  [modalId]="modalId"
  [classes]="
    isMobile
      ? '!z-[120] !h-auto bottom-0 rounded-t-lg'
      : '!z-[120] !h-auto !max-w-[560px] !rounded-lg'
  "
  overlayClasses="!z-[110]"
  [shouldSwipeDownToClose]="true"
  (modalClosed)="continueRequested.emit()"
>
  <div class="text-center px-2 py-1">
    <div
      class="mx-auto mb-3 flex h-[56px] w-[56px] items-center justify-center rounded-full bg-primary"
    >
      <img
        src="/assets/images/icons/founder.svg"
        alt=""
        class="h-[34px] w-[34px]"
        aria-hidden="true"
      />
    </div>
    <h2 class="mx-0 mb-2 text-center">
      {{ "FOUNDER_MODAL_TITLE" | translate }}
    </h2>
    <p class="mb-3 text-grey dark:text-borders-dark">
      {{ "FOUNDER_MODAL_BODY" | translate }}
    </p>
    <p class="mb-5 text-sm text-grey dark:text-borders-dark">
      {{ "FOUNDER_MODAL_EXPIRATION" | translate }}
    </p>
    <div class="flex justify-center">
      <button
        class="btn btn-small bg-black text-white dark:bg-white dark:text-black"
        type="button"
        (click)="continueRequested.emit()"
      >
        {{ "CONTINUE" | translate }}
      </button>
    </div>
  </div>
</app-modal>
